import { LOCALES } from '@marketplace/i18n';

export const partnerProfileFormI18n = {
  [LOCALES.ENG]: {
    developer_personal_page_partner_profile_company_name: 'Company Name',
    developer_personal_page_partner_profile_website: 'Website',
    developer_personal_page_partner_profile_country: 'Country',
    developer_personal_page_partner_profile_city: 'City',
    developer_personal_page_partner_profile_state: 'State / Province',
    developer_personal_page_partner_profile_postal_code: 'Postal Code',
    developer_personal_page_partner_profile_description: 'Description',
    developer_personal_page_personal_profile_tenant_id: 'Tenant ID',
    developer_personal_page_info_logo: 'png, jpg 172x172px. Max 1MB',
    developer_personal_page_info_logo_error: 'Max size 1MB',
    developer_personal_page_type_error: 'Select only jpg or png',
    developer_personal_page_partner_profile_address: 'Address',
  },
};
